import { afterNextRender, Component, forwardRef, input, output, signal, type OutputEmitterRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AbstractControl } from '../abstract-control/abstract-control';
import { CSSValuePipe } from '@pipes/css-value-pipe';

@Component({
  selector: 'app-radio',
  standalone: true,
  imports: [MatTooltipModule, CSSValuePipe],
  templateUrl: './radio.html',
  styleUrl: './radio.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Radio),
      multi: true,
    },
  ],
})
export class Radio extends AbstractControl<string, string> {
  // Inputs
  override $value = input.required<string>({ alias: 'value' });
  $name = input.required<string>({ alias: 'name' });

  // Outputs
  override valueChange: OutputEmitterRef<string> = output();

  // Signals / atributos
  override $controlValue = signal<string>('');

  // Verificar si se emitirá el valor al iniciar
  constructor () {
    super();

    afterNextRender(() => {
      if (this.$emitAtStart())
        this.valueChange.emit(this.$value());
    });
  }

  // Maneja el cambio del valor desde el input
  onValueChange(_event: Event): void {
    this.updateValue(this.$value());
    this.valueChange.emit(this.$value());
  }
}
